import styled from 'styled-components';

interface inputProps {
  valid?: boolean;
  filled?: boolean;
}

export const CpfContainer = styled.div<inputProps>`
  position: relative;
  width: 100%;
  border-radius: 4px;
  font-weight: 400;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    props.filled && !props.valid ? '2px solid #ff5670' : '1.5px solid #dfe4ef'};

  input {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.black};
    border: none;
    background: ${(props) => props.theme.colors.white};

    ::-webkit-input-placeholder {
      color: ${(props) => props.theme.colors.gray};
      padding-top: 5px;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
    }
  }

  span {
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  svg {
    color: #24c952;
    font-size: 20px;
    display: ${(props) => (props.filled && props.valid ? 'block' : 'none')};
  }

  .invalidCPF {
    display: ${(props) => (props.filled && !props.valid ? 'block' : 'none')};
    font-size: 14px;
    font-weight: 700;
    color: white;
    position: absolute;
    background: #ff5670;
    border-radius: 20px;
    padding: 3px 8px;
    bottom: -12px;
  }

  @media (max-width: 960px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 960px) {
    width: 100%;
    margin: 0 auto;
  }

  .title_receivecall {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 16px;
    color: ${(props) => props.theme.colors.black};
    line-height: 19.2px;
    width: 100%;

    .subtitle_receivecall {
      width: 100%;
      margin-top: 24px;

      .default {
        margin-top: 11px;
      }

      span {
        line-height: 16.9px;
        font-weight: 400;
        font-size: 16px;
        color: ${(props) => props.theme.colors.gray};
      }
    }

    .btns_receivecall {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      margin-top: 24px;

      p {
        font-size: 16px;
        color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;
